var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21,
    fill: "#FAFAFA",
    stroke: "#A5BFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.844 16.988V29.8342C30.844 31.0305 29.8743 32.0002 28.678 32.0002H15.3213C14.125 32.0002 13.1553 31.0305 13.1553 29.8342V12.166C13.1555 10.9697 14.125 10 15.3213 10H24.2673L30.844 16.988Z",
    fill: "#E03303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8438 16.988H25.7111C24.9136 16.988 24.2671 16.3415 24.2671 15.544V10L30.8438 16.988Z",
    fill: "#E9714F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5876 25.4735V26.9373H16.5483V22.625H18.2686C18.5986 22.625 18.8903 22.6858 19.1443 22.807C19.3983 22.9283 19.5941 23.1018 19.7338 23.326C19.8721 23.5503 19.9426 23.804 19.9426 24.0887C19.9426 24.509 19.7916 24.8445 19.4898 25.097C19.1896 25.348 18.7763 25.4735 18.2503 25.4735H17.5876ZM17.5876 24.671H18.2686C18.4703 24.671 18.6238 24.6218 18.7296 24.52C18.8353 24.42 18.8876 24.2775 18.8876 24.0942C18.8876 23.8925 18.8326 23.7318 18.7241 23.6105C18.6156 23.4908 18.4673 23.43 18.2798 23.4272H17.5876V24.671Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5344 25.4735V26.9373H20.4951V22.625H22.2154C22.5454 22.625 22.8371 22.6858 23.0911 22.807C23.3449 22.9283 23.5409 23.1018 23.6806 23.326C23.8189 23.5503 23.8894 23.804 23.8894 24.0887C23.8894 24.509 23.7384 24.8445 23.4366 25.097C23.1364 25.348 22.7231 25.4735 22.1971 25.4735H21.5344ZM21.5344 24.671H22.2154C22.4171 24.671 22.5706 24.6218 22.6764 24.52C22.7821 24.42 22.8344 24.2775 22.8344 24.0942C22.8344 23.8925 22.7794 23.7318 22.6709 23.6105C22.5624 23.4908 22.4141 23.43 22.2266 23.4272H21.5344V24.671Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8276 23.4272H26.5346V26.937H25.4939V23.4272H24.2246V22.625H27.8274L27.8276 23.4272Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg6);
export default __webpack_public_path__ + "static/media/svg6.5e42c6e10aec4ca000f87f2861019172.svg";
export { ForwardRef as ReactComponent };